import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const EmailCredentialList = Loadable(
  lazy(() => import("features/notification/credentialsEmail/components/List"))
);
const EmailCredentialPage = Loadable(
  lazy(() => import("features/notification/credentialsEmail/components/Page"))
);

const routes = {
  path: "email",
  children: [
    { path: "", element: <EmailCredentialList /> },
    { path: "add", element: <EmailCredentialPage /> },
    { path: "edit/:credentialID?", element: <EmailCredentialPage /> },
  ],
};

export default routes;
